(function () {
  'use strict';
  function initialize(root) {
    root.querySelectorAll('[data-application-form]').forEach(function (form) {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      var fields = form.querySelector('[data-application-fields]');
      var result = form.querySelector('[data-application-result]');
      var refresh = form.querySelector('[data-application-refresh]');
      var button = form.querySelector('[data-application-submit]');
      var other = form.querySelector('[data-other-business]');
      var previews = form.querySelector('[data-image-previews]');
      var busy = false;
      var previewUrls = [];
      function message(text, error) {
        result.textContent = text;
        result.dataset.state = error ? 'error' : 'info';
      }
      function showOther() {
        var selected = form.elements.business_type.value === 'other';
        other.hidden = !selected;
        form.elements.other_business.disabled = !selected;
        form.elements.other_business.required = selected;
      }
      form.elements.business_type.addEventListener('change', showOther);
      form.elements.images.addEventListener('change', function () {
        previewUrls.forEach(URL.revokeObjectURL);
        previewUrls = [];
        previews.replaceChildren();
        var files = Array.from(form.elements.images.files);
        var valid = files.length >= 1 && files.length <= 3 && files.every(function (file) {
          return ['image/jpeg', 'image/png', 'image/webp'].includes(file.type) && file.size <= 5 * 1024 * 1024;
        });
        form.elements.images.setCustomValidity(valid ? '' : 'Choose 1–3 JPG, PNG or WebP images, no larger than 5 MB each.');
        if (!valid) { form.elements.images.reportValidity(); return; }
        files.forEach(function (file) {
          var figure = document.createElement('figure');
          var img = document.createElement('img');
          var caption = document.createElement('figcaption');
          var url = URL.createObjectURL(file);
          previewUrls.push(url);
          img.src = url; img.alt = 'Selected review image';
          caption.textContent = file.name;
          figure.append(img, caption); previews.append(figure);
        });
      });
      async function requestJson(url, options) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 60000);
        try {
          var response = await fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal }, options));
          var json = (response.headers.get('content-type') || '').includes('application/json') ? await response.json() : null;
          if (response.status === 401) {
            var detail = json && (typeof json.detail === 'string' ? json.detail : json.message);
            if (detail === 'Please log in to your customer account') {
              throw new Error('Your customer session could not be verified. Please log in again, then return to this page.');
            }
            if (detail === 'Shop unavailable' || detail === 'Invalid shop') {
              throw new Error('Applications are unavailable for this store. Please contact us so we can check the store configuration.');
            }
            throw new Error('The application service could not verify this request. Please contact us if refreshing the status does not help.');
          }
          if (!response.ok || !json || json.success !== true) {
            throw new Error(json && typeof json.detail === 'string' ? json.detail : 'The application service is unavailable. Please try again later.');
          }
          return json;
        } finally { clearTimeout(timer); }
      }
      function showState(application) {
        var status = application && application.status;
        var editable = !application || status === 'rejected' || (status === 'revoked' && application.sync_status === 'synced');
        fields.hidden = !editable;
        fields.disabled = !editable;
        showOther();
        if (!application) message('Complete the form below to apply for price access.');
        else if (status === 'pending') message('Your application is awaiting review. You do not need to submit again.');
        else if (status === 'approved') message(application.sync_status === 'synced'
          ? 'Your price access has been enabled. Refresh this page to update your account.'
          : 'Your application is approved. Price access is still being activated. Please check again later.');
        else if (status === 'rejected') message('Your application was declined. ' + (application.review_note || '') + ' You may update your information and apply again.');
        else if (status === 'revoked') message('Your price access has been revoked. ' + (application.review_note || '') + (editable ? ' You may submit a new application.' : ' Your account is being updated.'));
        else { fields.disabled = true; message('Your application status could not be confirmed. Please contact us.', true); }
      }
      async function loadStatus() {
        if (busy) return;
        busy = true; refresh.disabled = true; fields.disabled = true;
        try {
          var data = await requestJson(form.dataset.statusUrl);
          if (typeof data.form_token !== 'string' || !Object.prototype.hasOwnProperty.call(data, 'application')) throw new Error('Your application status could not be confirmed.');
          form.elements.form_token.value = data.form_token;
          showState(data.application);
        } catch (error) {
          message(error.name === 'AbortError' || error instanceof TypeError ? 'Unable to connect. Please refresh your status to try again.' : error.message, true);
        } finally { busy = false; refresh.disabled = false; }
      }
      refresh.addEventListener('click', loadStatus);
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy) return;
        form.querySelectorAll('input:not([type="file"])').forEach(function (input) { input.value = input.value.trim(); });
        if (!form.reportValidity()) return;
        var body = new FormData(form);
        busy = true; fields.disabled = true; refresh.disabled = true;
        button.textContent = 'Submitting…'; message('Uploading your images and submitting your application…');
        try {
          var data = await requestJson(form.action, { method: 'POST', body: body });
          if (!data.application_id || data.status !== 'pending') throw new Error('Your submission could not be confirmed. Refresh your status before trying again.');
          showState(data);
        } catch (error) {
          message(error.name === 'AbortError' || error instanceof TypeError
            ? 'The connection was interrupted. Refresh your status to check whether your application was received before submitting again.' : error.message, true);
          fields.disabled = true;
        } finally {
          busy = false; refresh.disabled = false; button.textContent = 'Submit application'; result.focus();
        }
      });
      loadStatus();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
